module.exports = __webpack_public_path__ + "6270355f726e2952df05bfc8be524824.png";